import { AlignHorizontalLeft, Analytics, Compress, FilePresent, Folder, GroupAdd, List, MenuBook, PeopleAltOutlined, PrecisionManufacturingOutlined, Task, ViewQuilt } from "@mui/icons-material";
import { AppRoutes } from "../../router/routes";

export const NavBars = (
    id: string,
    isEdit: boolean = false,
    loading: boolean = false,
    tags: { tag_id: string, tag_name: string }[] = [],
    tag_group_id: string,
    technicalParameterPath: string,
) => ([
    {
        id: "1",
        title: "Basic Details",
        icon: <AlignHorizontalLeft fontSize="small" />,
        path: AppRoutes.viewProposalBasicDetail(id)
    },
     {
            id: "15",
            title: "Collaborate",
            disabled: !isEdit,
            icon: <PeopleAltOutlined fontSize="small" />,
            path: AppRoutes.collaborate('proposal', id)
    },
    {
        id: "2",
        title: "Data Table",
        icon: <Analytics fontSize="small" />,
        disabled: !isEdit,
        path: AppRoutes.viewProposalTechParamForm(id, technicalParameterPath)
    },
    {
        id: "12",
        title: "Task Manager",
        isBeta: true,
        disabled: !isEdit,
        icon: <Task fontSize="small" />,
        path: AppRoutes.tasks('proposal', id)
    },
    {
        id: "3",
        title: "Documents",
        disabled: !isEdit,
        icon: <Folder fontSize="small" />,
        path: AppRoutes.viewProposalDocuments(id)
    },
    // {
    //     id: "4",
    //     title: "IEDRAW",
    //     disabled: !isEdit,
    //     isBeta: true,
    //     icon: <Architecture fontSize="small" />,
    //     path: AppRoutes.viewProposalIEDraw(id),
    // },
    // {
    //     id: "5",
    //     title: "IEDOCS",
    //     disabled: !isEdit,
    //     isBeta: true,
    //     icon: <Article fontSize="small" />,
    //     path: AppRoutes.viewProposalIEDocs(id),
    // },
    {
        id: "6",
        title: "Material",
        disabled: !isEdit,
        icon: <FilePresent fontSize="small" />,
        path: AppRoutes.viewProposalMaterial(id) + "?tab=material"
    },
    {
        id: "7",
        title: "BOMs",
        disabled: !isEdit,
        icon: <ViewQuilt fontSize='small' />,
        path: AppRoutes.viewProposalBOM(id) + "?tab=bom",
    },
    {
        id: "8",
        title: "BOM Report",
        disabled: !isEdit,
        icon: <List fontSize='small' />,
        path: AppRoutes.viewBOMReportOnProposalModule(id) + "?tab=bomReport",
    },
    {
        id: "9",
        title: "List View",
        disabled: !isEdit,
        icon: <Compress fontSize='small' />,
        path: AppRoutes.viewListViewOnProposalModule(id) + "?tab=listView",
    },
    {
        id: "10",
        title: "Workbook",
        disabled: !isEdit,
        icon: <MenuBook fontSize='small' />,
        path: AppRoutes.workbookOnProposalModule(id) + "?tab=workbook",
    },
    // {
    //     id: "11",
    //     title: "Issue Tracker",
    //     disabled: !isEdit,
    //     icon: <Troubleshoot fontSize="small" />,
    //     path: AppRoutes.viewIssueTrackerOnProposal(id) + "?tab=issueTracker"
    // },
    {
        id: "13",
        title: "AI Search",
        disabled: !isEdit,
        icon: <PrecisionManufacturingOutlined fontSize="small" />,
        path: AppRoutes.viewProposalAISearch(id)
    },
    {
        id: "14",
        title: "Manage Users",
        disabled: !isEdit,
        icon: <GroupAdd fontSize="small" />,
        path: AppRoutes.manageUsersOnProposal(id)
    },
])
